<template>
  <div class="landing__faq">
    <landing-expand-panel
      v-for="(item, i) in faq"
      :key="i"
      :item="item"
      :active="activeQuestion === i"
      @click="(e) => setActiveQuestion(e, i)"
    />
  </div>
</template>

<script>
export default {
  name: "FAQ",

  data() {
    return {
      faq: this.$t('landing.faq.list'),
      activeQuestion: null,
      activeElement: null,
      verticalPadding: 32,
    }
  },

  methods: {
    setActiveQuestion(event, n) {
      if (this.activeQuestion === n) {
        this.activeElement.style.maxHeight = null;
        return this.activeQuestion = null;
      }

      if (this.activeElement) {
        this.activeElement.style.maxHeight = null;
      }

      this.activeQuestion = n;
      const panel = event.target.closest(".faq__question").nextElementSibling;
      this.activeElement = panel;

      if (panel) {
        panel.style.maxHeight = panel.scrollHeight + this.verticalPadding + "px";
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.landing__faq
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  margin: 0 auto
  gap: 16px
  max-width: 870px
</style>
